export default __webpack_public_path__ + "static/media/infographic-legaldesign.d62032f3.svg";